<template>
  <div id="footer_player" v-if="loaded" :class="(isInWidget ? 'in_widget' : '')" >
    
    <div class="footer_player_inner">
      <a  v-if="get_me()" class="close" @click="$emit('close')">x</a>
    <div :key="activeSongID" v-if="!isInWidget" class="pic" :style="'background-image:url(' + itemObj.pic_tumb + ')'"></div>
    <div class="details">
              <h3 v-text="itemObj.artist.name"></h3>
              <h4 v-text="activeSong.name"></h4>
    </div>
    <div class="options"  v-if="!isInWidget">
      <div @click="itemObj.is_like ? doUnlike() : doLike()" :key="itemObj.is_like" style="cursor:pointer; display:inline-block;">
          <i v-show="!itemObj.is_like" class="far fa-heart"></i>
          <i v-show="itemObj.is_like" class="fas fa-heart" style="color:#d82c2c"></i>
      </div>
    </div>
    <div class="player_wrapper">
      <vue-plyr :options="playerOptions" ref="plyr">
        <audio controls crossorigin playsinline :autoplay="autoplay !== false">
          <!-- <source :src="'https://www.linktone.co.il/lnk_download/listen?song_id=' + activeSongID" type="audio/mp3" /> -->
        </audio>
      </vue-plyr>
    </div>
    <div class="playlist_actions" v-show="songs.length > 1">
      <a @click="nextSong()"><i class="fas fa-forward"></i></a>
    </div>

    <div class="to_lt" v-if="!isInWidget">
      <a  @click="$emit('close'); $bus.$emit('open_widget', itemObj)"><img src="@/assets/ico_headphones.svg"><span>הצג לינקטון</span></a>
    </div>
</div>
  </div>
</template>

<script>

export default {
    props: ["item", "isInWidget","autoplay", "playlist"],
  data(){

    return {
      loaded: false,
      playerOptions: {
        controls: (this.is_mobile() ?  ['play','progress'] : ['play','progress', 'mute','volume'])
      }
    }
  },
  computed:{
    itemObj(){
      if (!this.isNull(this.playlist))
      {
        return this.activeSong;
      }
      else return this.item;
    },

    songs(){/*
      if (this.isNull(this.itemObj) || this.isNull(this.itemObj.songs)) return [];
      else return this.itemObj.songs;
      */
     if (!this.isNull(this.playlist)) return this.playlist;
     else return this.itemObj.songs;
    },
    activeSong(){
    
        for (let i in this.songs)
        {
            let songI = this.songs[i];
            if (songI.playing_now) return songI;
        }
        //this.songs[0].playing_now=true;

        return this.songs[0];
    },
    activeSongID(){
      if (this.isNull(this.activeSong)) return 0;
      else return this.activeSong.id;
    },
  },
  mounted(){
    this.loaded = true;
    setTimeout(() => {
      this.$refs.plyr.player.source = { type: 'audio', title: 'Example title', sources: [{
                  // src: 'https://www.linktone.co.il/lnk_download/listen?song_id=' + this.activeSongID + (this.$route.query.tk ? '&tk=' + this.$route.query.tk : ''),
                  src: this.activeSong.app_listen,
                    type: 'audio/mp3'
              }] };

      this.$refs.plyr.player.on('ended', () => this.ended())
      this.addStat();


      this.$refs.plyr.player.on('play', () => { this.$bus.$emit('audioPlay'); });

      this.$bus.$on('videoPlay', () => {
        if (this.$refs.plyr != undefined) this.$refs.plyr.player.pause();
      });
}, 300)
  },
  beforeUnmount(){
    this.$bus.$off('videoPlay');
  },
  methods:{
      doLike(){
        
        var self = this;
        this.api({ action: 'likes/add', data: { item_id: this.itemObj.id }}, function(){ 

            self.itemObj.is_like = true;
        });
      },
      doUnlike(){
        
        var self = this;
        this.api({ action: 'likes/remove', data: { item_id: this.itemObj.id }}, function(){ 
            self.itemObj.is_like = false;
        });
      },
      ended()
      { 
        this.nextSong()
      },
      nextSong(){
        
        if (this.songs.length > 1)
        {
          let currID = this.activeSong.id;

          let prevID = 0;
          for (let i in this.songs)
          {
              let songI = this.songs[i];
//console.log(prevID + ' ==' + currID, prevID == currID)
              if (prevID == currID)
              { 
                this.play_song(songI);
                //if (!this.isNull(this.playlist)) this.itemObj =  this.activeSong;
                return;
              }

              prevID = songI.id;
          }

        }
          
      },

      play_song(song)
      {
          for (let i in this.songs)
          {
            let songI = this.songs[i];
            songI.playing_now=false;
          }
          song.playing_now=true;

          //this.addStat();
      },
        
      addStat(){
          this.api({ action: 'stats/add', data: { type: 'play', lt_id: this.itemObj.id, song_id: this.activeSongID }});
      }

  },

  watch:{
    activeSongID(){
      
      this.$refs.plyr.player.source = { type: 'audio', title: 'Example title', sources: [{
            // src: 'https://www.linktone.co.il/lnk_download/listen?song_id=' + this.activeSongID + (this.$route.query.tk ? '&tk=' + this.$route.query.tk : ''),
            src: this.activeSong.app_listen,
            type: 'audio/mp3'
      }] };

      this.addStat();

/*
      this.$refs.plyr.player.src(
        {
                 src: 'https://www.linktone.co.il/lnk_download/listen?song_id=' + this.activeSongID,
                  type: 'audio/mp3'
            }
        );*/
    }
  }

  
}
</script>

<style lang="scss">
#footer_player { 
  &{ position: fixed; z-index: 999999; left: 50%; margin-left: -450px; bottom: 25px; width: 900px; height: 110px; border-radius: 120px; background: #fff; box-shadow: 0 25px 44px -10px rgba(0, 0, 0, 0.31); border: solid 1px rgba(221, 221, 221, 0.44); /*justify-content: center; align-items: center; display: flex;*/ padding: 0 45px;  }

  .close { position: absolute; right: 30px; top: -20px; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.31); height: 30px; width:30px; line-height: 30px; text-align: center; display: block; background: #fff; color: #333; border-radius: 100%;}

  .footer_player_inner { display: flex; justify-content: space-between; align-items: center; height: 100%; justify-content: center;}

  .pic { width: 68px; height: 68px; background-size: cover; border-radius: 4px;   box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.23); margin-left:15px; float: right; }
  .details { width:20%; 
      h3 { font-size: 26px; font-weight: bold; margin-bottom: 8px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; }
      h4 { font-size: 20px; font-weight: normal; opacity: 0.4; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;}
  }
  .options {  }
  .player_wrapper {  }
  .plyr--full-ui input[type=range] { color: #ff256e;}
  
  .to_lt { float: left; text-align: center; padding-top: 8px;
    img { width: 50px; height: auto; }
    span { display: block; color: #464646; font-weight: bold; font-size: 12px;}
    }

  .playlist_actions { display: flex;
    a { color: #4a5464 !important;}
  }


  &.in_widget {
    & { left: 55px; margin: 0px; background: #1e212a; color: #fff; border:none; width:490px; height: 70px; } 
    .footer_player_inner { display: flex !important; flex-direction: column;}
    .plyr__controls { background:none !important; padding:0px; }

    .player_wrapper { order: 1;}
    .details { order: 2; text-align: center; padding: 0; float: none; width: auto;
      h3{ display: inline; font-size: 12px; margin-left: 6px;}
      h4{ display: inline; font-size: 12px; opacity: 1; }
    }

    .plyr__controls__item  { color: #fff !important; }
    
  }

  @media (max-width: 600px){
    & { left: 10% !important; right: 10% !important; width: auto !important; height: 70px !important; margin: 0px !important; }
    .footer_player_inner { display: flex !important; flex-direction: column;}

    .player_wrapper { padding: 0px; order: 1;}
    .pic, .to_lt { display: none;}

    .options { display: none;}
    .plyr__controls { background:none !important; padding:0px; }

    .details { order: 2; text-align: center; padding: 0; float: none; width: auto;
      h3{ display: inline; font-size: 12px; margin-left: 6px; line-height: normal; }
      h4{ display: inline; font-size: 12px; opacity: 1; line-height: normal; }
    }
  }
}
</style>